import React from 'react';
import { useSelector } from 'react-redux';

import {
  PurchaseInformation,
  getPurchaseHistoryWithin6Months,
  PurchaseInitialState
} from 'common/modules/domain/purchase';
import { GET_PURCHASE_HISTORY_ID } from 'common/modules/domain/purchase';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import { ErrorState } from 'common/modules/app/errors';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { AppState } from 'pages';
import {
  PurchaseHistoryListMessage,
  MESSAGE_TYPES_KEY
} from 'pages/purchase/components/PurchaseHistoryListMessage';

/** Stateからエラーメッセージ用のPropsに変換する */
const _convertMessageProps = (
  fetchState: FetchState,
  errorState: ErrorState,
  histories: PurchaseInformation[]
): { show: boolean; messageType?: MESSAGE_TYPES_KEY } => {
  if (
    fetchState[GET_PURCHASE_HISTORY_ID] !== FetchStatus.UNTREATED &&
    fetchState[GET_PURCHASE_HISTORY_ID] !== FetchStatus.FAILED
  ) {
    return { show: false };
  }
  if (errorState.requestId === GET_PURCHASE_HISTORY_ID) {
    return { show: true, messageType: 'otherError' };
  }
  if (!histories.length) {
    return { show: true, messageType: 'notFoundAnyHistory' };
  }
  return { show: false };
};

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const purchaseState = useSelector<AppState, PurchaseInitialState>(
    (state) => state.domain.purchase
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const errorState = useSelector<AppState, ErrorState>(
    (state) => state.app.error
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const histories = getPurchaseHistoryWithin6Months(
    purchaseState.initialPurchasePlanList,
    false
  );

  return {
    ..._convertMessageProps(fetchState, errorState, histories),
    glossary: Glossary.instance(glState)
  };
};

/**
 * 履歴リストに表示するエラーメッセージのContainer Component
 */
export default function ContainerComponent() {
  const _props = useStateProps();
  return <PurchaseHistoryListMessage {..._props} />;
}
